export default {
    BaseURL: process.env.REACT_APP_BASE_URL,

    RecaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,

    System_Code: process.env.REACT_APP_SYSTEM_CODE,
    Is_White_Label: process.env.REACT_APP_IS_WHITE_LABEL === true || process.env.REACT_APP_IS_WHITE_LABEL === 'true',

    Business_Short_Code: process.env.REACT_APP_BUSINESS_SHORT_CODE,

    Login_Required: process.env.REACT_APP_LOGIN_REQUIRED !== false && process.env.REACT_APP_LOGIN_REQUIRED !== 'false',

    Succeed: { code: 100, content: 'Succeed' },
    erDataNotExisted: { code: 101, content: 'Dữ liệu không tồn tại' },
    erDataExisted: { code: 102, content: 'Dữ liệu đã tồn tại' },

    erCannotConnectDatabase: {
        code: 103,
        content: 'Không thể kết nối vào cơ sở dữ liệu'
    },
    erCannotQueryToDatabase: {
        code: 104,
        content: 'Không thể truy xuất dữ liệu'
    },
    erCannotCreateObject: { code: 105, content: 'Không thể tạo dữ liệu' },
    erInvalidRequest: { code: 106, content: 'Yêu cầu không hợp lệ' },
    erAuthenticationFailed: { code: 107, content: 'Xác thực thất bại' },
    erLoggedInOtherDevice: { code: 1071, content: 'Tài khoản đã đăng nhập trên thiết bị khác' },
    erObjectExisted: { code: 108, content: 'Dữ liệu đã tồn tại' },
    erObjectNotExisted: { code: 109, content: 'Dữ liệu không tồn tại' },
    erObjectIsLocked: { code: 110, content: 'Dữ liệu bị khóa' },
    erPermissionDenied: { code: 111, content: 'Không có quyền truy cập' },
    erUploadFailed: { code: 112, content: 'Upload thất bại' },
    erInvalidOTP: { code: 113, content: 'Sai mã OTP' },
    erCannotModifyObject: { code: 114, content: 'Không thể chỉnh sửa' },
    erCannotCreateLog: { code: 115, content: 'Không thể tạo log' },
    erNothingToUpdate: { code: 116, content: 'Không có gì mới để cập nhật' },
    erLogNotExisted: { code: 117, content: 'Log is not existed' },

    erAccountIsLocked: { code: 118, content: 'Tài khoản User đã bị khóa' },
    erUserExisted: { code: 119, content: 'Tài khoản User đã tồn tại' },
    erUserNotExisted: { code: 120, content: 'Tài khoản User không tồn tại' },
    erUserInvalid: { code: 121, content: 'Tài khoản User không hợp lệ' },
    erOverQuotaLimit: { code: 133, content: 'Tối đa gói dịch vụ !' },
    erServiceQuotaLocked: { code: 135, content: 'Hệ thống đang tạm khoá thao tác ghi do vượt hạn mức' }
};
